import { NotificationCard } from '../../components/Card';
import { Flex, Icon, Center, Button } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { LayersThree01 } from '@kula-ai/icons/dual-tone/LayersThree01';
import { NotificationTime } from '../../components/Time';
import {
  RequisitionDetailsSection,
  RequisitionDetailsList,
  useRequisitionData,
} from './components';
import { KText } from '@/ui-library/components';

const RequisitionRejected = ({ notification = {}, onClose = () => {} }) => {
  const {
    requisition_id,
    requisition_code,
    requisition_ids,
    requisition_codes,
    role_name,
    rejection_reason,
    note,
    buildRequisitionDetails,
    requester_name,
    submitted_by_name,
  } = useRequisitionData(notification);

  const history = useHistory();

  const displayCode = requisition_codes
    ? Array.isArray(requisition_codes)
      ? requisition_codes.join(', ')
      : requisition_codes
    : requisition_code;

  const rejectionNote = rejection_reason || note;

  const detailsData = buildRequisitionDetails([
    { label: 'Requested by', value: requester_name || 'User' },
  ]);

  const handleEditRequisition = () => {
    if (requisition_id || requisition_ids?.[0]) {
      const targetId = requisition_id || requisition_ids?.[0];
      const isGroup = requisition_ids && requisition_ids.length > 1;

      const url = isGroup
        ? `/requisitions?edit=${targetId}&apply_to_group=true`
        : `/requisitions?edit=${targetId}`;

      history.push(url);
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="pastel-2-light">
        <Icon as={LayersThree01} color="pastel-2-dark" width="16px" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText>
          <KText as="span" fontWeight="semiBold">
            {submitted_by_name || 'User'}
          </KText>{' '}
          has rejected requisition{' '}
          <KText as="span" fontWeight="semiBold">
            {displayCode}
          </KText>{' '}
          for{' '}
          <KText as="span" fontWeight="semiBold">
            {role_name}
          </KText>
        </KText>

        <RequisitionDetailsSection
          title="Rejection reason"
          isCollapsible={false}
        >
          <Flex flexDir="column" gap="16px" p="16px" bg="white">
            {rejectionNote && (
              <KText size="sm-medium" whiteSpace="pre-wrap">
                {rejectionNote}
              </KText>
            )}
            <KText size="sm-medium" color="secondary-700">
              Rejected by:
              <KText as="span" fontWeight="regular" ml="4px">
                {submitted_by_name || 'User'}
              </KText>
            </KText>
          </Flex>
        </RequisitionDetailsSection>

        <RequisitionDetailsSection>
          <RequisitionDetailsList data={detailsData} />
        </RequisitionDetailsSection>

        <Button
          variant="primary"
          onClick={handleEditRequisition}
          size="sm"
          w="fit-content"
        >
          Edit requisition
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const RequisitionRejectedNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <RequisitionRejected notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
